import React from 'react';

export const ListaFacturas = () => {
	return [
		{
			fotoFactura:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse1.mm.bing.net%2Fth%3Fid%3DOIP.f_8EvyyRdsiVsNOsNXJHjQHaE7%26pid%3DApi&f=1&ipt=35fc4f4f445eb43cee3885bfc5597895cc6b82f16d4e39cd8899175666cbcffa&ipo=images',
			nombreCliente: 'Tyrion Lamnister',

			fechaFacturacion: '10/09/2022',
			peridodoInit: '06/09/2022',
			peridoFinal: '10/09/2022',
			numeroFactura: '1',
			tipoServicio: 'Cuidado personal',
			horasDias: '3',
			precioHora: '10',
			tipoTarjeta: 'Master card',
			numTarjeta: '1234-1234-1234-1234',
			cargdoAdicionales: '0',
			totalFactura: '135',
			pagoAgencia: '110',
			estadoPago: 'noPagado',
		},
		{
			fotoFactura:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse1.mm.bing.net%2Fth%3Fid%3DOIP.f_8EvyyRdsiVsNOsNXJHjQHaE7%26pid%3DApi&f=1&ipt=35fc4f4f445eb43cee3885bfc5597895cc6b82f16d4e39cd8899175666cbcffa&ipo=images',
			nombreCliente: 'Danerys Targarian',
			fechaFacturacion: '10/08/2022',
			peridodoInit: '06/08/2022',
			peridoFinal: '10/08/2022',
			numeroFactura: '2',
			tipoServicio: 'Cuidado personal',
			horasDias: '3',
			precioHora: '10',
			tipoTarjeta: 'Master card',
			numTarjeta: '1234-1234-1234-1234',
			cargdoAdicionales: '0',
			totalFactura: '135',
			pagoAgencia: '110',
			estadoPago: 'noPagado',
		},
		{
			fotoFactura:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse1.mm.bing.net%2Fth%3Fid%3DOIP.f_8EvyyRdsiVsNOsNXJHjQHaE7%26pid%3DApi&f=1&ipt=35fc4f4f445eb43cee3885bfc5597895cc6b82f16d4e39cd8899175666cbcffa&ipo=images',
			nombreCliente: 'John Nieve',
			fechaFacturacion: '10/07/2022',
			peridodoInit: '06/07/2022',
			peridoFinal: '10/07/2022',
			numeroFactura: '3',
			tipoServicio: 'Cuidado personal',
			horasDias: '3',
			precioHora: '10',
			tipoTarjeta: 'Master card',
			numTarjeta: '1234-1234-1234-1234',
			cargdoAdicionales: '0',
			totalFactura: '135',
			pagoAgencia: '110',
			estadoPago: 'pagado',
		},
		{
			fotoFactura:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse1.mm.bing.net%2Fth%3Fid%3DOIP.f_8EvyyRdsiVsNOsNXJHjQHaE7%26pid%3DApi&f=1&ipt=35fc4f4f445eb43cee3885bfc5597895cc6b82f16d4e39cd8899175666cbcffa&ipo=images',
			nombreCliente: 'Sansa Stark',
			fechaFacturacion: '10/06/2022',
			peridodoInit: '06/06/2022',
			peridoFinal: '10/06/2022',
			numeroFactura: '4',
			tipoServicio: 'Cuidado personal',
			horasDias: '3',
			precioHora: '10',
			tipoTarjeta: 'Master card',
			numTarjeta: '1234-1234-1234-1234',
			cargdoAdicionales: '0',
			totalFactura: '135',
			pagoAgencia: '110',
			estadoPago: 'noPagado',
		},
		{
			fotoFactura:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse1.mm.bing.net%2Fth%3Fid%3DOIP.f_8EvyyRdsiVsNOsNXJHjQHaE7%26pid%3DApi&f=1&ipt=35fc4f4f445eb43cee3885bfc5597895cc6b82f16d4e39cd8899175666cbcffa&ipo=images',
			nombreCliente: 'Rodrigo Antes',
			fechaFacturacion: '10/05/2022',
			peridodoInit: '06/05/2022',
			peridoFinal: '10/05/2022',
			numeroFactura: '5',
			tipoServicio: 'Cuidado personal',
			horasDias: '3',
			precioHora: '10',
			tipoTarjeta: 'Master card',
			numTarjeta: '1234-1234-1234-1234',
			cargdoAdicionales: '0',
			totalFactura: '135',
			pagoAgencia: '110',
			estadoPago: 'noPagado',
		},
		{
			fotoFactura:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse1.mm.bing.net%2Fth%3Fid%3DOIP.f_8EvyyRdsiVsNOsNXJHjQHaE7%26pid%3DApi&f=1&ipt=35fc4f4f445eb43cee3885bfc5597895cc6b82f16d4e39cd8899175666cbcffa&ipo=images',
			nombreCliente: 'Juan Antonio Pepe',
			fechaFacturacion: '10/04/2022',
			peridodoInit: '06/04/2022',
			peridoFinal: '10/04/2022',
			numeroFactura: '6',
			tipoServicio: 'Podologia',
			horasDias: '5',
			precioHora: '20',
			tipoTarjeta: 'Visa',
			numTarjeta: '1234-1234-6543-1234',
			cargdoAdicionales: '3',
			totalFactura: '543',
			pagoAgencia: '222',
			estadoPago: 'noPagado',
		},
		{
			fotoFactura:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse1.mm.bing.net%2Fth%3Fid%3DOIP.f_8EvyyRdsiVsNOsNXJHjQHaE7%26pid%3DApi&f=1&ipt=35fc4f4f445eb43cee3885bfc5597895cc6b82f16d4e39cd8899175666cbcffa&ipo=images',
			nombreCliente: 'Maria Hogaldo',
			fechaFacturacion: '10/03/2022',
			peridodoInit: '06/03/2022',
			peridoFinal: '10/03/2022',
			numeroFactura: '7',
			tipoServicio: 'Cuidado inter-personal',
			horasDias: '3',
			precioHora: '10',
			tipoTarjeta: 'Master card',
			numTarjeta: '1234-3245-1234-1234',
			cargdoAdicionales: '0',
			totalFactura: '335',
			pagoAgencia: '110',
			estadoPago: 'pagado',
		},
		{
			fotoFactura:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse1.mm.bing.net%2Fth%3Fid%3DOIP.f_8EvyyRdsiVsNOsNXJHjQHaE7%26pid%3DApi&f=1&ipt=35fc4f4f445eb43cee3885bfc5597895cc6b82f16d4e39cd8899175666cbcffa&ipo=images',
			nombreCliente: 'Maria Hogaldo',
			fechaFacturacion: '10/02/2022',
			peridodoInit: '06/02/2022',
			peridoFinal: '10/02/2022',
			numeroFactura: '7',
			tipoServicio: 'Cuidado inter-personal',
			horasDias: '3',
			precioHora: '10',
			tipoTarjeta: 'Master card',
			numTarjeta: '1234-3245-1234-1234',
			cargdoAdicionales: '0',
			totalFactura: '335',
			pagoAgencia: '110',
			estadoPago: 'pagado',
		},
		{
			fotoFactura:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse1.mm.bing.net%2Fth%3Fid%3DOIP.f_8EvyyRdsiVsNOsNXJHjQHaE7%26pid%3DApi&f=1&ipt=35fc4f4f445eb43cee3885bfc5597895cc6b82f16d4e39cd8899175666cbcffa&ipo=images',
			nombreCliente: 'Maria Hogaldo',
			fechaFacturacion: '10/01/2022',
			peridodoInit: '06/01/2022',
			peridoFinal: '10/01/2022',
			numeroFactura: '7',
			tipoServicio: 'Cuidado inter-personal',
			horasDias: '3',
			precioHora: '10',
			tipoTarjeta: 'Master card',
			numTarjeta: '1234-3245-1234-1234',
			cargdoAdicionales: '0',
			totalFactura: '335',
			pagoAgencia: '110',
			estadoPago: 'pagado',
		},
	];
};
